/**
 * @voltxampere/ui — 74HC14 hex Schmitt-trigger inverter (Sprint 43-7, full hysteresis)
 *
 * Sprint 42-1 shipped this as a placeholder against the standard
 * combinational digital-gate path. Sprint 43 ADR-0064 introduced the
 * Schmitt branch (`outputType: "schmitt"`) on the same `digital-gate`
 * canonical engine type — the variant now activates that branch with
 * V_T+ / V_T- typical values from the TI SN74HC14 datasheet at Vcc=5V.
 * Hysteresis loop is observable via warm-started chained DC solves
 * (see `sprint-43-schmitt-hysteresis-loop.test.ts`).
 *
 * Reference: TI SN74HC14. V_T+ typ 1.7 V, V_T- typ 0.9 V at Vcc=5 V.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic74hc14 = {
    id: "74hc14",
    nameTr: "74HC14 (6'lı Schmitt NOT, DIP-14)",
    nameEn: "74HC14 (Hex Schmitt NOT, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "74HC14",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        outputType: "schmitt",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        vThresholdPlus: 1.7,
        vThresholdMinus: 0.9,
        propagationDelay: 12e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-74hc14.js.map